import { render, staticRenderFns } from "./ClipMarkers.vue?vue&type=template&id=f229fb30&scoped=true&"
import script from "./ClipMarkers.vue?vue&type=script&lang=js&"
export * from "./ClipMarkers.vue?vue&type=script&lang=js&"
import style0 from "./ClipMarkers.vue?vue&type=style&index=0&id=f229fb30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f229fb30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
